<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Evaluation method(s)',
            data: [{
              x: 0,
              y: 1,
              data: 2,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
